/**
 * User: WangMeng
 * Date: 2018-04-16
 * Time: 9:46
 * Desc: 公司搜索
 */

import commonStyles  from '../common/common.scss';
import styles  from './companySearchForm.scss';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { Form } from 'antd';
import CompanyAutoComplete from '../../../common/companyAutoComplete/CompanyAutoComplete';
const FormItem = Form.Item;

class CompanySearchForm extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getCompanyInfo = (selectedCompany) => {
        this.selectedCompany = selectedCompany;
    };

    resetCompanyInfo = (v) => {
        if (!this.selectedCompany || v !== this.selectedCompany.name) {
            this.selectedCompany = null;
        }
    };

    onSubmit = (e) => {
        e.preventDefault();
        const { onSearch } = this.props;
        const { validateFields, setFields } = this.props.form;

        validateFields({ force: true }, (err, values) => {
            if (!err) {
                if (!this.selectedCompany) { // 没有选择公司
                    setFields({
                        company: {
                            value: values.company,
                            errors: [new Error('请选择公司')]
                        }
                    });
                    return;
                }
                onSearch && onSearch({ companyCode: this.selectedCompany.code });
            }
        });
    };

    render() {
        const { className } = this.props;
        const { getFieldDecorator } = this.props.form;
        return (
            <div className={classNames('search-bar', commonStyles.searchBar, styles.companySearchBox, className)}>
                <Form hideRequiredMark onSubmit={this.onSubmit}>
                    <FormItem className={classNames('company-name-with-button')}>
                        {getFieldDecorator('company', {
                            rules: [{
                                required: true, message: '请输入公司名称或代码'
                            }],
                            initialValue: ''
                        })(
                            <CompanyAutoComplete placeholder="请输入公司名称或代码" getCompanyInfo={this.getCompanyInfo} onChage={this.resetCompanyInfo}/>
                        )}
                        <button type="submit" className="btn btn-blue">搜索</button>
                    </FormItem>

                </Form>
            </div>
        );
    }
}

export default (Form.create({})(CompanySearchForm));



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/company/CompanySearchForm.jsx